import axios from 'axios';
import { getToken, removeToken } from './Token';
import { getClientonly } from '.';
import router from '@/router';
import { BASE_URL } from '@/common/const';
import { ElMessage, ElMessageBox } from 'element-plus';

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
});

request.interceptors.request.use(
  (config) => {
    const clientonly = getClientonly();
    config.headers['device-id'] = clientonly;
    const token = getToken();
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

request.interceptors.response.use(
  (response) => {
    if (response.data.code === 0) {
      return response.data.data;
    }
    ElMessage.error(response.data.message);
    return Promise.reject(response.data.message);
  },
  (error) => {
    console.log('request+++++error:', error);
    if (!error.response) {
      ElMessage.error("网络异常");
      return Promise.reject("网络异常");
    }
    const data = error.response.data || { message: "网络异常" };
    if (data.code === 408) {
      localStorage.removeItem("dev-password")
      ElMessageBox.prompt(data.message)
        .then(({ value }) => {
          if (value) { localStorage.setItem("dev-password", value) }
        })
        .catch(() => { });
    } else if (data.code === 401) {
      removeToken();
      ElMessageBox.confirm("登录已过期，请重新登录", {}).then(() => {
        router.push('/login');
      }).catch(() => { })
    } else {
      ElMessage.error(data.message || "网络异常");
    }
    return Promise.reject(data.message || "网络异常");
  },
);

export default request;
